import { render, staticRenderFns } from "./dev-page.vue?vue&type=template&id=578da238&"
import script from "./dev-page.vue?vue&type=script&lang=js&"
export * from "./dev-page.vue?vue&type=script&lang=js&"
import style0 from "./dev-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports